import { Icon } from 'js/components/common/Icon';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { usePrevious } from 'js/hooks/usePrevious';
import { getClassNames } from 'js/utils/classNames.util';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import style from './DiscoveryCategoryHeaderBanner.scss';

export const DiscoveryCategoryHeaderBanner = ({
    children,
    translationKey,
    state = 'header',
    text,
    counter,
    useShape = false,
    activeTab,
    mixPanelTrackCallback
}) => {
    const t = usePortletTranslations();
    const classesMy = [style[state], style.dot].join(' ');

    const [active, setActive] = useState(counter === 0);
    const [height, setHeight] = useState('0px');

    const content = useRef(null);
    const prevCounter = usePrevious(counter);
    const prevActiveTab = usePrevious(activeTab);

    const toggleAccordion = useCallback((_active) => {
        if (_active) {
            setActive(true);
            setHeight(`${content.current?.scrollHeight || 0}px`);
        } else {
            setActive(false);
            setHeight('0px');
        }
    }, [content]);

    useEffect(() => {
        if (counter > 0 && prevCounter === 0) {
            toggleAccordion(true);
        } else if (counter <= 0 && prevCounter > 0) {
            toggleAccordion(false);
        } else if (prevCounter !== counter || prevActiveTab !== activeTab) {
            toggleAccordion(counter > 0);
        }
    }, [activeTab, prevActiveTab, toggleAccordion, counter, prevCounter]);

    const onHeaderClick = useCallback(() => {
        if (counter <= 0) {
            return;
        }
        mixPanelTrackCallback(active ? 'section-expanded' : 'section-collapsed', translationKey);
        toggleAccordion(!active);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counter, toggleAccordion, active]);

    return (
        <div>
            <div onClick={onHeaderClick} className={style.myOwnSpecialStyle}>
                <div className={style.discovery}>
                    {useShape && <div className={style.textShape} />}
                    {!useShape && <div
                        className={`${style.text} ${style.withoutBackButton}`}>
                        <div className={classesMy} />
                        <p className={style.categoryLabel}>{text || t(translationKey)}</p>
                        <p className={style.categoryLabel}>{`(${counter})`}</p>
                    </div>}
                    <div className={style.arrowWrapper}>
                        <Icon type="discoveryIconArrow" className={getClassNames([
                            style.icon,
                            active && style.expanded
                        ])} />
                    </div>
                </div>
            </div>
            <div ref={content} style={{ maxHeight: `${height}` }} className={style.accordion__content}>
                {children}
            </div>
        </div>
    );
};
